import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import MessageItem from "./MessageItem";
import TypingIndicator from "./TypingIndicator";

var useStyles = makeStyles(function () {
  return {
    scrollArea: {
      flex: 1,
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#ddd",
        borderRadius: "3px",
      },
    },
    loadingWrap: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    },
    userMessage: {
      maxWidth: "720px",
      margin: "0 auto",
      padding: "20px 24px 4px 24px",
      "@media (max-width: 768px)": {
        padding: "16px",
      },
    },
    assistantMessage: {
      maxWidth: "720px",
      margin: "0 auto",
      padding: "16px 24px 20px 24px",
      "@media (max-width: 768px)": {
        padding: "16px",
      },
    },
    divider: {
      maxWidth: "720px",
      margin: "0 auto",
      borderTop: "1px solid #f3f4f6",
    },
    typingWrap: {
      maxWidth: "720px",
      margin: "0 auto",
      padding: "16px 24px 20px 24px",
    },
  };
});

var MessageList = function MessageList({
  messages,
  sendingMessage,
  loadingConversation,
  onFollowUpSelect,
  userName,
  messagesAreaRef,
  messagesEndRef,
}) {
  var classes = useStyles();
  var prevMsgCountRef = useRef(messages ? messages.length : 0);
  var lastAssistantRef = useRef(null);

  useEffect(
    function () {
      var currentCount = messages ? messages.length : 0;
      var prevCount = prevMsgCountRef.current;
      prevMsgCountRef.current = currentCount;

      if (sendingMessage && messagesEndRef && messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        return;
      }

      // Only smart-scroll for a single new assistant message (not conversation load)
      if (currentCount > prevCount && currentCount - prevCount <= 2 && !sendingMessage && lastAssistantRef.current) {
        lastAssistantRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      if (messagesEndRef && messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    },
    [messages, sendingMessage]
  );

  if (loadingConversation) {
    return (
      <div className={classes.scrollArea} ref={messagesAreaRef}>
        <div className={classes.loadingWrap}>
          <CircularProgress size={28} style={{ color: "#1e3a5f" }} />
        </div>
      </div>
    );
  }

  if (!messages || messages.length === 0) {
    return null;
  }

  var currentCount = messages.length;
  var items = [];
  for (var i = 0; i < messages.length; i++) {
    var msg = messages[i];
    // Add divider between Q&A pairs (before each user message except the first)
    if (msg.role === "user" && i > 0) {
      items.push(<div key={"div-" + i} className={classes.divider} />);
    }

    var wrapClass = msg.role === "user" ? classes.userMessage : classes.assistantMessage;
    var isNewMessage = !sendingMessage && i === messages.length - 1 && prevMsgCountRef.current > 0 && currentCount - prevMsgCountRef.current <= 2 && currentCount > prevMsgCountRef.current;
    var wrapStyle = msg.role === "assistant" ? { scrollMarginTop: "20px" } : {};
    var wrapRef = (msg.role === "assistant" && i === messages.length - 1) ? lastAssistantRef : undefined;

    items.push(
      <div key={msg.id || i} className={wrapClass} style={wrapStyle} ref={wrapRef}>
        <MessageItem
          message={msg}
          isLast={i === messages.length - 1}
          isNew={isNewMessage}
          sendingMessage={sendingMessage}
          onFollowUpSelect={onFollowUpSelect}
          userName={userName}
        />
      </div>
    );
  }

  return (
    <div className={classes.scrollArea} ref={messagesAreaRef}>
      {items}
      {sendingMessage && (
        <>
          <div className={classes.divider} />
          <div className={classes.typingWrap}>
            <TypingIndicator />
          </div>
        </>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
